module.exports = __webpack_public_path__ + "img/PrincipalSirVisi.72132c41.jpg";